<template>
    <div id="wholecontent">
       <teleport to="head">
        <component :is="'script'" type="application/ld+json">
        {{this.jsonld}}
        </component>
      </teleport>

        <v-container fluid id="subnav" class="py-0 px-0 print--hide mt-6">
          <v-container class="container d-flex justify-space-between align-center flex-wrap" id="subnavcontainer">
            <p style="display: inline;" class="subline">{{jobObj.title}}</p>
            <div class="d-flex align-center subline-nextline"> 
              <a id="downloadBtn" href="" class="d-flex align-center link black b p--bold print--hide" style="font-size: 12px;line-height:12px;" onclick="print(); return false;">
                {{$t("message.downloadjobaspdf")}} 
                <span class="material-icons ml-2">save_alt</span>
              </a>
              <applyDialog :job="jobObj"/>
            </div>
          </v-container>
          <v-divider/>
        </v-container>
    <v-container class="container">
      <v-row>
        <v-col cols="12" md="8">
          <h1 id="jobTitle" style="padding-bottom:0px !important;">{{jobObj.title}}</h1>
          <p class="my-7 light">{{jobObj.location}} {{ jobObj.location != "" ? " | " : " " }} {{jobObj.job_categories.replace(";", " • ")}} {{ jobObj.job_categories != "" ? " | " : " " }} {{jobObj.type.replace(";", " • ")}}</p>
          <description v-if="jobObj.description" class="text--overwrite"  :contentHtml="jobObj.description" /> 
          <description v-if="jobObj.tasks" class="text--overwrite" :title="$t('message.yourTasks')" :ulContentHtml="jobObj.tasks" />
          <description v-if="jobObj.expectations" class="text--overwrite" :title="$t('message.yourProfile')" :ulContentHtml="jobObj.expectations" />
          <description v-if="jobObj.salary_description && jobObj.location != 'IT - Milan'" class="text--overwrite" :title="$t('message.weoffer')" :text="$t('message.weofferText')" :text2="jobObj.salary_description"/>
          <description v-else-if="!jobObj.salary_description && jobObj.location != 'IT - Milan'" class="text--overwrite" :title="$t('message.weoffer')" :text="$t('message.weofferText')"/>
          
          <div v-if="specialBenefit" class="mb-3" >
            <h3  v-if="specialBenefit.english">{{$t("message.specialBenefitForLoc")}}</h3>
            <img v-if="specialBenefit.image" :src="specialBenefit.image" class="mb-3"/>
            <p v-if="specialBenefit.english">{{ language == 'en' ? specialBenefit.english.substr(8) : specialBenefit.deutsch.substr(8) }}</p>
          </div>
          
          <accordion :title="$t('message.application')"  type="application" />
          <accordion title="Loxone" type="aboutLoxone" />
          <accordion v-if="location && location.country" :title="$t('message.location')" type="location" :location="location"/>
          <accordion :title="$t('message.similarjobs')" type="similarJobs" :similarJobs="jobObj.similarJobs"/>
        </v-col>

        <v-col cols="12" md="4" class="pr-0">
          <div v-if="contact.name" class="bg--lightgray px-4 py-4" >
            <h4>{{ $t("message.interestedQ") }}</h4>
            <p>{{ $t("message.yourContactperson") }}:</p>
            <img class="mb-3" id="img-contactperson" :src="contact.image" style="max-height:120px !important; "/>
            <p class="p--bold my-2">{{contact.name}}</p>

            <div class="d-flex align-center mb-4">           
              <div class="mr-2 d-flex align-center"><Icon icon="material-symbols:mail-outline" width="16.67" /></div>
              <a class="black" style="font-size: 16px" :href="`mailto:https://jobs.loxone.com/de/jobs/detail/${this.id}/`">{{ contact.email }}</a>
            </div>   
            <div class="d-flex  mb-4">
              <div class="mr-2"><Icon icon="mi:call" width="16.67" height="16.67"  /></div>
              <div>
                <p>
                <span v-if="contact.phone">{{contact.phone}}<br></span>
                <span v-if="contact.phone_2">{{contact.phone_2}}<br></span>
                <span v-if="contact.phone_3">{{contact.phone_3}}<br></span>
                </p> 
              </div>
            </div>
            <div class=" d-flex align-center mb-4">           
              <div class="mr-2 d-flex align-center"><Icon icon="basil:linkedin-solid" width="16"/></div>
              <a class="mr-2 black" target="_blank" :href="contact.linkedin">
                  {{$t("message.gotolinkedinprofile")}}
              </a>
            </div>   

            <v-divider class="my-5"/>
            <div class="">
            <p class="mb-4">{{$t("message.recommendjob")}}: </p>
            <a class="mr-2" target="_blank" :href="`https://api.whatsapp.com/send?text=https://jobs.loxone.com/de/jobs/detail/${this.id}/`">
              <img src="https://jobs.loxone.com/wp-content/loxone/theme/images/whatsapp.png" alt="Whatsapp" decoder="async">
            </a>
            <a class="mr-2" target="_blank" :href="`https://www.linkedin.com/shareArticle?mini=true&url=https://jobs.loxone.com/de/jobs/detail/${this.id}/`">
              <img src="https://jobs.loxone.com/de/wp-content/uploads/sites/2/2021/04/IC-LinkedIn.svg" alt="LinkedIn" decoder="async">
            </a>
            <a class="mr-2" target="_blank" :href="`https://www.xing.com/spi/shares/new?url=https://jobs.loxone.com/de/jobs/detail/${this.id}/`">
              <img src="https://jobs.loxone.com/de/wp-content/uploads/sites/2/2021/04/IC-Xing.svg" alt="Xing" decoder="async">
            </a>
            <a class="mr-2" target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=https://jobs.loxone.com/de/jobs/detail/${this.id}/`">
              <img src="https://jobs.loxone.com/de/wp-content/uploads/sites/2/2021/04/IC-FB.svg" alt="Facebook" decoder="async">
            </a>
            <a class="mr-2" target="_blank" :href="`mailto:?subject=Loxone: ${jobObj.title}&body=${jobObj.title}%0D%0Ahttps://jobs.loxone.com/de/jobs/detail/${this.id}/`">
              <img src="https://jobs.loxone.com/wp-content/loxone/theme/images/mail.png" alt="Mail" decoder="async">
            </a>
            </div>
          </div>

          <div style="min-width:300px" class="mb-3">
            <h4 class="pb-2 mt-9" v-if="benefitsArr.length != 0">{{$t("message.benefitsloxone")}}</h4>
            <div v-for="benefit of benefitsArr" :key="benefit" style="height: 70px !important;margin-top: 5px;">
              <v-row class="my-0 align-center justify-content-center">
                <v-col cols="2"><img width="50" height="50" class="benefit--icon" :src="benefit.image"></v-col>
                <v-col cols="10" class="pl-5">
                  <p>{{benefit.text}}</p>
                </v-col>                
              </v-row>
              <v-divider/>
            </div>
          </div>

        </v-col>
      </v-row>
      </v-container>
    </div>
</template>



<script>
import description from '@/components/description.vue';
import accordion from '@/components/accordion.vue';
import axios from "axios";
import { Icon } from '@iconify/vue';
import { i18nUsage } from '../main.js'
import applyDialog from '@/components/applyDialog.vue';

export default {
    name: 'JobDetailView',
    components: { 
      description,
      accordion,
      Icon,
      applyDialog
    },

    props: {
      id: {
        type: String,
      },
    },
    data() {
      return {
        benefitsArr: [],
        jobObj: {},
        contact: {},
        location: {},
        specialBenefit: {},
        language: 'en',
      }
    },
    methods: {
      async getData() {
        let res = await axios.get(`https://jobs.loxone.com/wp-content/loxone/jobs-api/?zoho_id=${window.location.href.split('/')[6]}`);
        this.jobObj = res.data;
        // console.log("this.jobobj", this.jobObj);
        this.jobObj.id = this.id;

        switch(this.jobObj.language) {
          case 'German':
            this.language = 'de';
            break;
          case 'Polish':
            this.language = 'pl';
            break;
          case 'Slovak':
            this.language = 'sk';
            break;
          case 'Czech':
            this.language = 'cz';
            break;
          case 'Dutch':
            this.language = 'nl';
            break;
          case 'Spanish':
            this.language = 'es';
            break;
          case 'French':
            this.language = 'fr';
            break;
          case 'Italian':
            this.language = 'it';
            break;
          default:
            this.language = 'en';
            break;
        }

        //Load Benefits
        let benefitsData = new FormData();
        benefitsData.append('wanted_benefits', res.data.benefits);
        axios({
            method: 'post',
            withCredentials: true,
            crossDomain: true,
            data: benefitsData,
            url: '/wp-content/loxone/jobs-api/api_handler.php?action=getJobBenefits&lang=' + this.language,
            baseURL: 'https://jobs.loxone.com',
        }).then((response) => {
            this.benefitsArr = response.data.benefits;
            // console.log("Benefits", this.benefitsArr);
        }, (error) => {
			    console.log(error);
        });

        //Load CONTACT
        let contactData = new FormData();
        contactData.append('contact', this.jobObj.recruiter);
        axios({
            method: 'post',
            withCredentials: true,
            crossDomain: true,
            data: contactData,
            url: '/wp-content/loxone/jobs-api/api_handler.php?action=getJobContact&lang=' + this.language,
            baseURL: 'https://jobs.loxone.com',
        }).then((response) => {
            this.contact = response.data.contact_data;
            console.log("this.contact", this.contact);
        }, (error) => {
            console.log(error);
        });

		//Load LOCATION
		let locationData = new FormData();
		locationData.append('location', this.jobObj.location);
    if(this.jobObj.location == "PL - Warszawa"){ // Poland handling - wrong address
      this.location =  {
        city: "Warszawa",
        country: "PL",
        image: "https://jobs.loxone.com/wp-content/uploads/2023/09/Polen_Warschau.jpg",
        latitude: "52.181020",
        longitude: "20.969920",
        post_code: "02-146",
        street: "Komitetu Obrony Robotników 70",
        title: "PL - Warszawa"
      }
      return;
    }
		axios({
			method: 'post',
			withCredentials: true,
			crossDomain: true,
			data: locationData,
			url: '/wp-content/loxone/jobs-api/api_handler.php?action=getJobLocation&lang=' + this.language,
			baseURL: 'https://jobs.loxone.com',
		}).then((response) => {
			this.location = response.data.location_data;
      this.getSpecialBenefit(this.location.title); //look for special benefits at location
      // console.log("location: ",this.location);
		}, (error) => {
			console.log(error);
		});

      },


      async getSimilarJobs(){
        let res = await axios.get(`https://jobs.loxone.com/wp-content/loxone/jobs-api/?zoho_id=${this.id}`);
        this.jobObj = res.data;
      },

      async getInitialJobData(){
        let res = await axios.get(`https://jobs.loxone.com/wp-content/loxone/jobs-api/?zoho_id=${this.id}`);
        this.jobObj = res.data;
      },
      async getSpecialBenefit(locTitle){
        if(!locTitle){
          return;
        }
        let locationTitle = locTitle.toLowerCase().split(" ");
        locationTitle = locationTitle.filter(elm => elm.length > 1);
        let slug = locationTitle.join("-");

          let res = await axios.get(`https://jobs.loxone.com/wp-json/wp/v2/benefits?slug=${slug}`);
          let data = res.data;
          let allbenefits = data[0].acf.benefit;
          let found = allbenefits.find(elm => elm["deutsch"].substr(0,8) == "SPECIAL-");
          if (found){
              let res_img = await axios.get(`https://jobs.loxone.com/wp-json/wp/v2/media/${found.icon}`);
              let res_img_data = res_img.data;
              found.image = res_img_data.guid.rendered;
              this.specialBenefit = found;
          }else{ this.specialBenefit = {}}
      },
    },
    async created () {
      await this.getData();
      /*this.jsonld = `      
        "@context"  :  "https://schema.org/",
          "@type"     :  "JobPosting",
          "title"     :   ${this.jobObj.title},
          "description" : ${this.jobObj.description},
          "hiringOrganization" : {
            "@type"   :    "Organization",
            "name"    : "Loxone",
            "sameAs"  : "https://www.loxone.com/",
            "logo"    : "https://jobs.loxone.com/de/wp-content/uploads/sites/2/2021/05/Loxone-Logo.png"
          },
          "employmentType": "CONTRACTOR",
          "datePosted"  : ${this.jobObj.insert_timestamp},
          "validThrough": ${this.jobObj.opened},
          "jobLocation" : {
            "@type"     : "Place",
            "address"   : {
              "@type"   : "PostalAddress",
              "streetAddress"   : ${this.locations[this.jobObj.location]['street']},
              "addressLocality" : ${this.locations[this.jobObj.location]['city']},
              "postalCode"      : ${this.locations[this.jobObj.location]['postalcode']},
              "addressCountry"  : ${this.jobObj.location.split(' ')[0]}
            }
          },
          "baseSalary"  : {
              "@type"   : "MonetaryAmount",
              "currency": ${this.jobObj.currency},
              "value"   : {
                "@type"     : "QuantitativeValue",
                "minValue"  : ${this.jobObj.insert_timestamp.split('-')[0]},
                "maxValue"  : ${this.jobObj.insert_timestamp.split('-')[1]},
                "unitText"  : "YEAR"
              }
            }
        };`  */

      if(this.jobObj.language == 'German'){
        i18nUsage.global.locale = "de";
      }
      else{
        i18nUsage.global.locale = "en";
      }
      document.getElementById("rowcontent-section").setAttribute("style", "padding: 0 0 !important;"); 
    },
  }
</script>



<style lang="css">

  @media print {
    #footer{
      display: none !important;
    }
    .print--hide{
      display: none !important;
      visibility: hidden !important;
    } 
    #downloadBtn{
      display: none !important;
    }
    #rowcontent-detail{
      margin: 0px !important;
      padding: 0px !important;
      width: 100% !important;
      display: block !important;
      visibility: visible !important;
      top:0; 
      overflow-x: auto;
      overflow-y: auto;
    }
    #wholecontent{
      background-color: #ffffff;
    }
    #main-header{
      display: none;
    }
  }

  #img-contactperson{
    height: 120px;
    width: 120px;
  }

  #rowcontent-detail{
    top: 30px ;
  }

  .text--overwrite  { /* some content are saved as html in the db -> used for overwriting them */
    line-height: 1.6em;
    font-size: 16px;
    font-family: 'averta-regular' !important;
  }

  span.font {
    font-family: 'averta-regular' !important;
    font-size: 16px;
  }

  #subnav{
    border-bottom: 0.5px solid #000000;
  }

  .benefit--icon{
      height: 100%;
      filter:  brightness(0) saturate(100%);
      max-width: 50px;
  }

  .link{
    text-decoration: none;
    color: #000000;
  }
  .container{
    max-width: 1260px;
  }
  .subline-nextline{
    margin-top: 10px;
  }
  #jobTitle {
    font-size: 3vw;
  }

  @media(max-width: 960px) {
  .b {
    margin-left: auto;
    order: 1;
  }

  #subnavcontainer{
    padding-top: 0px !important;
    padding-bottom: 30px;
  }
  #subnav .btn{
    margin-left: 0px !important;
    margin-right: min(20px, 64px);
    min-width: 161px;
    max-height: 48px;
    white-space:nowrap;
    overflow: hidden;
  }

   #jobTitle {
    margin-bottom: 0px !important; 
    font-family: 'Averta';
    font-style: normal;
    font-weight: 800;
    font-size: 32px;
    line-height: 32px;
  }
  p.subline {
    margin-bottom: 15px;
  }  
}

</style>
